
import React from 'react';
import { Box, Card, Divider, TableBody } from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Sample from "../../AdminDashboard/Onsite And Offsite/Sample.json";
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Paginator from "../../../toolkit/Paginator";
import RightArrowOpen from "../../../icons/RightArrowOpen.svg";
import Edit from "../../../icons/edit.svg";
import Trash from "../../../icons/trash1.svg";
import Avatar from "../../../icons/Avatar.svg";
import Restoreicon from "../../../icons/Restoreicon.svg";
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useState, useEffect } from 'react';
import { MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import axios from '../../../utils/fvAxios';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Nodata from "../../Nodata/Nodata";
import { ToastContainer, toast } from 'react-toastify';
import { HasScreenPermissions, HasPermissions } from '../../../utils/Token';
import INFO from '../../../pages/commom/RouteUrlInfo.json';
import PER from "../../../utils/Enums.json";


export default function DocumentTypes() {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.action.hover,

        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
            marginBottom: "20px"
        },
    }));
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: 200,
            },
        },
    };
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };


    const [open, setOpen] = useState(false);
    const [id, setID] = useState("");
    const [DocumentTypesList, setDocumentTypesList] = React.useState([]);
    const [spinner, setSpinner] = React.useState(false);
    const [Restrict, setRestrict] = useState("0");
    const [Expiry, setExpiry] = useState("0");
    const [DocumentTypeName, setDocumentTypeName] = useState("");
    const [DocumentTypeId, setDocumentTypeId] = useState("");
    const [Count, setCount] = useState("");
    const [number, setNumber] = useState("1");
    const [Search, setSearch] = useState("");

    const handleClickOpen = (num, data) => {
        setID(num);
        setOpen(true);
        setRestrict(num == 1 ? "0" : data?.restrictAccess == true ? "1" : "0");
        setExpiry(num == 1 ? "0" : data?.documentExpires == true ? "1" : "0");
        setDocumentTypeName(num == 1 ? "" : data?.documentTypeName);
        setDocumentTypeId(num == 1 ? "-1" : data?.documentTypeId);
    };
    const handleClose = () => {
        setOpen(false);
    };


    const FreeSearch = (e) => {
        handlePageChange("1");
        setSearch(e);
    }
    const SpinnerClose = () => {
        setSpinner(false);
    };

    useEffect(() => {
        GetDocumentTypesList();
    }, [Search, number]);

    const handlePageChange = (event) => {
        setNumber(event);
    };

    async function GetDocumentTypesList() {
        setSpinner(!spinner);
        const res = await axios.get("SystemUser/GetDocumentTypesList?freeText=" + Search + "&pageNumber=" + number + "&pageSize=" + 12);
        setDocumentTypesList(res?.data?.data);
        setCount(res?.data?.count);
        setSpinner(spinner);
    }

    const AddorEditDocument = async () => {
        if (DocumentTypeName != "") {
            const obj = {
                "documentTypeName": DocumentTypeName,
                "documentExpires": Expiry == 0 ? false : true,
                "isEdit": id == 1 ? false : true,
                "restrictAccess": Restrict == 0 ? false : true,
                "documentTypeId": DocumentTypeId
            }

            const res = await axios.post("SystemUser/AddOrUpdateDocumentType", obj);
            if (res?.data?.responseCode == 100) {
                toastNotify(res?.data?.data, true);
                GetDocumentTypesList();
                handleClose();
            } else {
                toastNotify(res?.data?.responseMessage, false);
                setOpen(true);
            }
        } else {
            toastNotify("Please enter mandatory fields", false);
            setOpen(true);
        }
    }
    return (
        <>
            <ToastContainer />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
                onClick={SpinnerClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Card>
                <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
                    <DialogContent sx={{ padding: "48px 48px" }}>
                        <DialogTitle
                            sx={{
                                textAlign: "center",
                                fontWeight: 500,
                                fontSize: 20,
                            }}
                        >
                            <span style={{ fontSize: "larger" }} >{id == 1 ? " Add Document Type" : " Edit Document Type"}</span>
                        </DialogTitle>

                        <DialogActions >
                            <div>

                                <div className=''>

                                    <div >
                                        <span style={{ color: "#3E4A62" }}>Document Type Name <span style={{ color: "red" }}>*</span></span>
                                        <br />
                                        <TextField
                                            placeholder='Document Type Name'
                                            sx={{
                                                "& legend": { display: "none" },
                                                "& fieldset": { top: 0 },
                                                fontFamily: "Arial, FontAwesome"
                                            }}
                                            variant="outlined"
                                            size="small"
                                            value={DocumentTypeName || ""}
                                            onChange={(e) => setDocumentTypeName(e?.target?.value)}
                                        />

                                    </div>
                                    <div className='mt-3'>
                                        <span style={{ color: "#3E4A62" }}>Has Expiry </span>
                                        <br />

                                        <FormControl>
                                            <RadioGroup
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                name="radio-buttons-group"
                                                value={Expiry}
                                                onClick={(e) => setExpiry(e?.target?.value)}
                                            >
                                                <FormControlLabel value={1} control={<Radio />} label="Yes" />
                                                <FormControlLabel value={0} control={<Radio />} label="No" />

                                            </RadioGroup>
                                        </FormControl>

                                    </div>
                                    <div className='mt-3'>
                                        <span style={{ color: "#3E4A62" }}>Restrict Access </span>
                                        <br />

                                        <FormControl>
                                            <RadioGroup
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                name="radio-buttons-group"
                                                value={Restrict}
                                                onClick={(e) => setRestrict(e?.target?.value)}
                                            >
                                                <FormControlLabel value={1} control={<Radio />} label="Yes" />
                                                <FormControlLabel value={0} control={<Radio />} label="No" />

                                            </RadioGroup>
                                        </FormControl>

                                    </div>

                                </div>

                                <DialogActions >
                                    <div className="login-help__buttonContainer mt-4">
                                        <Button variant="contained" className="login-help-button-cancel mx-2" onClick={handleClose}>Cancel</Button>
                                        <Button variant="contained" className="login-button-request mx-2" onClick={AddorEditDocument}>{id == 1 ? "Add " : "Save"}</Button>
                                    </div>

                                </DialogActions>
                            </div >
                        </DialogActions>



                    </DialogContent>
                </Dialog>

                <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                    <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                        <h3> Document Types</h3>
                    </div>
                </div>

                <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />

                <div style={{ marginLeft: "15px", marginBottom: "15px" }} >
                    <Stack spacing={2} direction="row">
                        <TextField
                            placeholder='Search'
                            sx={{
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                                fontFamily: "Arial, FontAwesome"
                            }}
                            variant="outlined"
                            size="small"
                            value={Search}
                            onChange={(e) => FreeSearch(e?.target?.value)}
                        />
                        {/* {!HasScreenPermissions(INFO?.AddDocumentType?.actionName) &&
                            <div style={{ marginLeft: "Auto", padding: "10px" }}>
                                <Button variant="contained" sx={{ padding: "inherit" }} onClick={() => handleClickOpen(1, "")}>+ Add New</Button>
                            </div>
                        } */}
                        {(HasPermissions(INFO?.AddDocumentType?.actionName, PER?.ScreenPermissions?.Insert) && HasPermissions(INFO?.DocumentTypesList?.actionName, PER?.ScreenPermissions?.Insert)) &&
                            <div style={{ marginLeft: "Auto", padding: "10px" }}>
                                <Button variant="contained" sx={{ padding: "inherit" }} onClick={() => handleClickOpen(1, "")}>+ Add New</Button>
                            </div>
                        }
                    </Stack >

                </div>
                <Box sx={{ backgroundColor: '#f8f9fa' }}>
                    {DocumentTypesList?.length < 1 ? <div hidden={spinner}><Nodata /> </div> : <>
                        <TableContainer component={Paper} sx={{ borderBottom: 0 }}>
                            <Table aria-label="customized table">

                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}>Document Type Name</span>	</StyledTableCell>
                                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Document Expires</span></StyledTableCell>
                                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Restricted Access</span></StyledTableCell>
                                        <StyledTableCell >&nbsp;</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                {DocumentTypesList?.map((r, i) => (
                                    <TableBody key={i}>
                                        <TableRow key={i} >
                                            <StyledTableCell sx={{ width: "30%" }}>
                                                {r?.documentTypeName}
                                            </StyledTableCell>

                                            <StyledTableCell sx={{ width: "30%" }} >
                                                {r?.documentExpires == true ? "True" : "False"}
                                            </StyledTableCell>

                                            <StyledTableCell sx={{ width: "30%" }} >
                                                {r?.restrictAccess == true ? "True" : "False"}
                                            </StyledTableCell>

                                            <StyledTableCell sx={{ width: "5%" }} >
                                                {(HasPermissions(INFO?.AddDocumentType?.actionName, PER?.ScreenPermissions?.Modify) && HasPermissions(INFO?.DocumentTypesList?.actionName, PER?.ScreenPermissions?.Modify)) &&
                                                    <IconButton aria-label="edit" onClick={() => handleClickOpen(2, r)}>
                                                        <img src={Edit} alt="editicon" />
                                                    </IconButton>
                                                }
                                            </StyledTableCell>


                                        </TableRow>

                                    </TableBody>
                                ))}
                            </Table>

                        </TableContainer>
                    </>
                    }
                </Box >


            </Card>
            <div hidden={DocumentTypesList == ""}>
                <Paginator
                    count={Math.ceil(Count / 12)}
                    page={Number(number)}
                    margin="18px 0px"
                    onChange={handlePageChange}
                />
            </div>
        </>
    )
}


